import React, { useEffect, useState } from "react";
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import dayOfYear from "dayjs/plugin/dayOfYear";
import ReportTable from "./ReportTable";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import { axiosInstance } from "../../utils/networking";
dayjs.extend(utc);
dayjs.extend(dayOfYear);

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 20,
  },
  page_title: {
    fontSize: 24,
    color: "white",
    backgroundColor:
      process.env.REACT_APP_API_DOMAIN != "https://www.thrive-drive.org:8443"
        ? "rgb(63, 93, 125)"
        : "rgb(158, 31, 99)", // Background color matching the page title
    marginBottom: 15,
    marginTop: 15,
    paddingLeft: 15,
    paddingVertical: 10,
    fontWeight: "bold", // Bold font weight
    textTransform: "uppercase", // Uppercase text
  },
  section_title: {
    fontSize: 18,
    color: "black",
    marginBottom: 10,
    marginTop: 10,
    paddingLeft: 10,
    paddingVertical: 5,
    fontWeight: "bold", // Bold font weight for section titles
    backgroundColor: "#e0e0e0", // Light grey background color
    borderLeftWidth: 6, // Left border
    borderLeftColor:
      process.env.REACT_APP_API_DOMAIN != "https://www.thrive-drive.org:8443"
        ? "rgb(63, 93, 125)"
        : "rgb(158, 31, 99)", // Border color matching the page title background
  },
});

const AllBFCReport = (props: any) => {
  const startDate = props.startDate;
  const endDate = props.endDate;

  const [reportData, setReportData] = useState<any>({});
  const startDateString = startDate ? startDate.format("YYYY-MM-DD") : "";
  const endDateShow = endDate || dayjs();
  const endDateString = endDateShow.format("YYYY-MM-DD");
  const [dataFlag, setDataFlag] = useState(false);

  useEffect(() => {
    if (startDate === null && endDate === null) {
      axiosInstance.get(`/user/allBfcReport`).then((result) => {
        setReportData(result.data);
        setDataFlag(true);
      });
    } else if (startDate !== null && endDate === null) {
      axiosInstance
        .get(`/user/allBfcReport?startDate=${startDate.toDate()}`)
        .then((result) => {
          setReportData(result.data);
          setDataFlag(true);
        });
    } else {
      axiosInstance
        .get(
          `/user/allBfcReport?startDate=${startDate.toDate()}&endDate=${endDate.toDate()}`
        )
        .then((result) => {
          setReportData(result.data);
          setDataFlag(true);
        });
    }
  }, []);
  if (dataFlag) {
    return (
      <PDFViewer width="100%" height="700px">
        <Document>
          <Page size="LETTER" style={styles.page} key="reportData">
            <View>
              <Text style={styles.page_title}>Report Data</Text>
              {startDate && (
                <Text style={styles.section_title}>
                  {startDateString} to {endDateString}
                </Text>
              )}
            </View>
            <ReportTable data={reportData} />
          </Page>
        </Document>
      </PDFViewer>
    );
  } else {
    return <></>;
  }
};

export default AllBFCReport;
